import { useDispatch, useSelector } from 'react-redux'

import actions from 'actions/auth'
import { menuLoadBoxPrices } from 'actions/menu'
import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { getPricePerServing } from 'routes/BoxPrices/boxPricesSelectors'
import { useLoadMenuCutoffUntil } from 'routes/Menu/MenuRecipesPage/useLoadMenuCutoffUntil'
import { useBasket } from 'routes/Menu/domains/basket'
import menuFetchData from 'routes/Menu/fetchData'

/**
 * Experiments running on home page that controls order or visibility
 * of homepage sections should be placed here
 */
export const useGetHomePageExperiments = () => {
  const isPriceComparisonTableEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_price_comparison_table_web_enabled',
  )
  const isHowGoustoWorksEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_how_gousto_works_web_enabled',
  )
  const isValueForMoneyEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_value_for_money_web_enabled',
  )

  return {
    isPriceComparisonTableEnabled,
    isHowGoustoWorksEnabled,
    isValueForMoneyEnabled,
  }
}

export const useGetPricePerServing = () => useSelector(getPricePerServing)

export const useGetMenuData = () => {
  useLoadMenuCutoffUntil()
  const dispatch = useDispatch()
  const pricePerServing = useGetPricePerServing()
  const { addRecipe } = useBasket()
  const dispatchRedirectLoggedInUser = () => dispatch(actions.redirectLoggedInUser)
  const dispatchMenuFetchData = () =>
    dispatch(menuFetchData({ query: {}, params: {} }, false, true, '', { addRecipe }))
  const dispatchMenuLoadBoxPrices = () => dispatch(menuLoadBoxPrices())

  return {
    dispatchRedirectLoggedInUser,
    dispatchMenuFetchData,
    dispatchMenuLoadBoxPrices,
    pricePerServing,
  }
}
